import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Clooping(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
     
      <Sides/>
       <Helmet>
 
 <title>C++ looping tutorial For Beginners</title>
 <meta name="description" content="C++ looping tutorial for beginners.looping statement in C++ is used to repeat a particular piece of cards until the given condition is false.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C++ looping tutorial for beginners,programming language tutorial for begineers,c++ looping,looping in c++,c++ looping programs,looping in c++ programming,cpp language looping,looping in cpp language,c++ programming looping examples,looping in c++ programming pdf,looping in c++ pdf,cpp programming looping exercises,cpp programming looping statements,cpp language looping statement,looping in c++ in hindi,looping in cpp in english,cpp looping structures in embedded systems,c++ program for looping,learn code in free,c++ programming tutorial for beginners,learn code in free online" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-looping" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C++ looping</h1>
    <div className="first">
        <a href="/cpp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">A looping statement in C++ is using to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are three types of looping statements in C++ programming:
</h2>
<h3 className="mt-4 mh3">1, Using a while looping in C++ statement<br/>
2, Using a do-while looping in C++ statement<br/>
3, Using a for looping in C++ <br/>

</h3>
<h2 className="mt-4 mh2">1, While loop in C++:</h2>
<p className="mt-4 para">In the while loop for C++, The loop's body executes until that the condition is false.
</p>


<h2 className="headings">while loop C++ Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">while</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-7">condition</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-2">&#123;</span>
              {"\n"} 
            <span className="qwerty-2">  -  </span>
            {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-2">  -  </span>
              {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

<h2 className="mt-4 mh2">2,Do-while loop:</h2>
<p className="mt-4 para">In the do-while Loop, Loop Check after the execution of the Loop's body, and the main thing is that the Loop's body executes at least once.
</p>


<h2 className="headings">Do-while loop C++ Syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">do </span>
            <span className="qwerty-2">&#123;</span>
              {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-2">  -  </span>
              {"\n"}
              <span className="qwerty-2">  while</span>
              <span className="qwerty-3"> (</span>
              <span className="qwerty-4">condition</span>
              <span className="qwerty-3">);</span>
              {"\n"} 
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


<h2 className="mt-4 mh2">3, For loop C++:</h2>
<p className="mt-4 para">1, In the for loop C++, the body of the Loop will be executed until the given condition is false<br/>
2, This for Loop is using to repeat a particular piece of code for a fixed no of times<br/>
3, In the for loop C++ In for Loop must use two semicolons<br/>
</p>


<h2 className="headings">for loop C++ syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">for</span>
              <span className="qwerty-7"> (</span>
              <span className="qwerty-5"> statement</span>
              <span className="qwerty-7">; </span>
              <span className="qwerty-3">condition</span>
            <span className="qwerty-7">;</span>
            <span className="qwerty-5">statement</span>
            <span className="qwerty-7">)</span>
              {"\n"} 
              <span className="qwerty-4">  statement</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Clooping;